import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { ESTILO_BOTON_LISTAR_ATRAS, } from "../../../utils/const/estilos-const";
import { useTranslation } from "react-i18next";
import spinner from "../../../assets/iconos/spinner4.svg";
import readXlsxFile from "read-excel-file";
// import { INDEX_COLUMNAS_EXCEL } from "./concepto";

import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { STRING_COLOR_PRIMARIO } from "../../../utils/const/string-const";
import { COLOR_AZUL_MAIN, COLOR_ROJO } from "../../../utils/const/colors-const";
import shortid from "shortid";
// import moment from "moment";
import { exportarLink, sharedNextPage } from "../../../utils/shared-functions";
// import { obtenerListaEmpresaPlataforma } from "../../../api/api-empresa-plataforma";
// import Select from "react-select";
import { guardarImportarExcelSellers, obtenerConfiguracionExcelImportarSellers } from "../../../api/api-configuracion-importar-excel-sellers";

ModuleRegistry.registerModules([AllCommunityModule]);

export default function AdvanceSellers() {

    const { t } = useTranslation();

    const columnDefs = [
        {
            field: "acciones", headerName: t("column_actions"),
            cellRenderer: (params) => {
                // console.log('cellRenderer');
                // console.log(params);
                return (
                    <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                        <button
                            onClick={() => handleDelete(params.data)}
                            style={{
                                backgroundColor: COLOR_ROJO,
                                color: "white",
                                border: "none",
                                padding: "5px 10px",
                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                        >
                            {t("label_delete")}
                        </button>
                    </div >
                );
            }
        },
        { field: "id", headerName: "ID", hide: true },
        { field: "code", headerName: "CODE", filter: true, sortable: true, },
        { field: "name", headerName: "NAME", filter: true, sortable: true, },
        { field: "note", headerName: "NOTE", filter: true, sortable: true, },
    ];

    const history = useHistory();
    const [columnasExcelPersonal, setColumnasExcelPersonal] = useState(null);
    const columnasExcelPersonalRef = useRef(columnasExcelPersonal);
    // const dateInputRef = useRef(null);
    // const [fechaAdquisicion, setFechaAdquisicion] = useState("");
    const [loading, setLoading] = useState(false);

    const [primaryColor, setPrimaryColor] = useState(COLOR_AZUL_MAIN);
    const [rowData, setRowData] = useState([]);

    // const [listEmpresas, setListEmpresas] = useState([]);
    // const [empresaSelected, setEmpresaSelected] = useState(null);

    useEffect(() => {
        columnasExcelPersonalRef.current = columnasExcelPersonal;
    }, [columnasExcelPersonal]);

    useEffect(() => {
        try {
            const fileUpload = document.getElementById("fileUpload");
            fileUpload.addEventListener("change", () => {
                readXlsxFile(fileUpload.files[0]).then((rows) => {
                    reset();
                    procesarExcel(rows);
                    fileUpload.value = "";
                });
            });
            iniciar();
            const mainColor = localStorage.getItem(STRING_COLOR_PRIMARIO);
            if (mainColor !== null) {
                setPrimaryColor(mainColor);
            }
        } catch (e) {
            console.error(e.message);
        }
    }, []);

    const handleDelete = (data) => {
        try {
            const newRowData = rowData.filter((row) => row.id !== data.id);
            setRowData(newRowData);
        } catch (err) {
            console.log('handleDelete err');
            console.log(err);
        }
    };

    const iniciar = async () => {
        try {
            const resp = await obtenerConfiguracionExcelImportarSellers();
            if (resp.error === false && resp.body !== null) {
                setColumnasExcelPersonal(resp.body);
            }
            // const listEmpresas = await obtenerListaEmpresaPlataforma({ habilitado: 1 }, true, t);
            // console.log('listEmpresas');
            // console.log(listEmpresas);
            // setListEmpresas(listEmpresas);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        }
    };

    const importar = () => {
        try {
            document.getElementById("fileUpload").click();
        } catch (err) {
            console.log("importarExcel err");
            console.log(err);
        }
    };

    const exportar = () => {
        try {
            const link =
                "https://gestion.boltrack.net/assets/template-import-sub-sellers.xlsx";
            exportarLink(link, "template-import-sellers.xlsx");
        } catch (err) {
            console.log("importarExcel err");
            console.log(err);
        }
    };

    const handleAtrasClick = () => {
        // history.goBack();
        window.location.href = "/administer";
    };

    const reset = () => {
        try {
            setRowData([]);
        } catch (err) {
            console.log('reset err');
            console.log(err);
        }
    };

    const procesarExcel = (rows) => {
        try {
            // console.log('procesarExcel');
            // console.log(rows);
            // console.log('columnasExcelPersonalRef.current');
            // console.log(columnasExcelPersonalRef.current);
            if (rows.length === 0) {
                return [];
            }
            rows.shift();
            let indexCode = 0;
            let indexName = 1;
            let indexNote = 2;
            if (columnasExcelPersonalRef.current !== null) {
                indexCode = columnasExcelPersonalRef.current['indexCode'];
                indexName = columnasExcelPersonalRef.current['indexName'];
                indexNote = columnasExcelPersonalRef.current['indexNote'];
            }
            let data = [];
            for (let index = 0; index < rows.length; index++) {
                const element = rows[index];
                let obj = {};
                obj.id = shortid.generate();
                obj.code = element[indexCode] !== undefined ? element[indexCode] : null;
                obj.name = element[indexName] !== undefined ? element[indexName] : null;
                obj.note = element[indexNote] !== undefined ? element[indexNote] : null;
                data.push(obj);
            }
            setRowData(data);
        } catch (error) {
            console.log('procesarExcel err');
            console.log(error);
        }
    };

    const onCLickGuardar = async () => {
        try {
            setLoading(true);
            // console.log(rowData);
            if (rowData.length === 0) {
                alert(t("label_error_empty_data"));
                setLoading(false);
                return;
            }
            let objEnviar = {};
            objEnviar = rowData;
            const resp = await guardarImportarExcelSellers(objEnviar);
            // console.log("resp", resp);
            if (resp.error === false) {
                alert(t('alert_created_success'));
                sharedNextPage("list-sellers", {}, history);
            }
            if (resp.error === true) {
                alert(resp.message);
            }
            setLoading(false);
        } catch (err) {
            console.log('onCLickGuardar err');
            console.log(err);
            setLoading(false);
        }
    };

    const render = () => {
        try {
            // if (cargandoPage === true) {
            //     return cargandoCard();
            // }
            return (
                <div className="p-4">
                    <div className="flex justify-between">
                        <label
                            style={{
                                fontWeight: 'bold',
                            }}
                        >
                            {t("title_manage_import")}
                        </label>
                        <div className="flex justify-center">
                            <button
                                type="button"
                                className={ESTILO_BOTON_LISTAR_ATRAS}
                                onClick={(handleAtrasClick)}
                            >
                                {t("label_back")}
                            </button>
                        </div>
                    </div>
                    <br />
                    <div className="flex justify-between items-end gap-4">
                        <div></div>
                        <div className="flex gap-4">
                            <button
                                className="bg-[#84B044] rounded text-white p-2 flex-none"
                                onClick={() => importar()}
                            >
                                IMPORTAR
                            </button>
                            <button
                                className="bg-[#84B044] rounded text-white p-2 flex-none"
                                onClick={() => exportar()}
                            >
                                EXPORTAR
                            </button>
                        </div>

                        <input
                            id="fileUpload"
                            type="file"
                            className="my-auto text-white p-[5px] px-[10px] mr-[10px] hidden"
                            accept=".xlsx,.xls"
                        />
                    </div>

                    <br />
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                            <div
                                className="ag-theme-alpine"
                                style={{
                                    height: "512px",
                                    width: "100%",
                                    "--ag-header-background-color": `${primaryColor}`,
                                }}
                            >
                                <AgGridReact
                                    rowData={rowData}
                                    columnDefs={columnDefs}
                                    pagination={true}
                                    rowHeight={50}
                                />
                            </div>
                        </div>
                    </div>
                    <br />
                    <div className="flex justify-end">
                        {loading === false && (
                            <button
                                onClick={() => { onCLickGuardar(); }}
                                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition duration-300"
                            >
                                GUARDAR
                            </button>
                        )}
                        {loading === true && (
                            <button className="login_button flex justify-center">
                                <img className="spinner"
                                    alt="spinner" src={spinner} />
                            </button>
                        )}
                    </div>
                </div>
            );
        } catch (err) {
            console.log('SettingsExcelEquipo render err');
            console.log(err);
            return (
                <div><label>{JSON.stringify(err)}</label></div>
            );
        }
    };

    return render();
}